/* tslint:disable */
/* eslint-disable */
/**
 * Nightingale API
 *  ### Welcome to the Nightingale API !   To use the Nightingale API, you will need a `access_token` from **Bridgetech Support**  ## How to use swagger documentation   Click `Authorize` and paste your  `access_token` as `bearerAuth`  ## Design Notes 1. For non-mandatory fields, the API will allow you to submit `null` *or* omit fields entirely. 2. All query parameters are optional. Pagination fields default as follows: * page = 1 * limit = 20
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';

/**
 * 
 * @export
 * @interface Notification
 */
export interface Notification {
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    body?: string;
    /**
     * 
     * @type {number}
     * @memberof Notification
     */
    case_id?: number | null;
    /**
     * 
     * @type {User}
     * @memberof Notification
     */
    user: User;
    /**
     * 
     * @type {Date}
     * @memberof Notification
     */
    read_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Notification
     */
    created_at: Date;
    /**
     * 
     * @type {Array<Array<string>>}
     * @memberof Notification
     */
    data?: Array<Array<string>>;
}

/**
 * Check if a given object implements the Notification interface.
 */
export function instanceOfNotification(value: object): value is Notification {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('user' in value) || value['user'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    return true;
}

export function NotificationFromJSON(json: any): Notification {
    return NotificationFromJSONTyped(json, false);
}

export function NotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Notification {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'body': json['body'] == null ? undefined : json['body'],
        'case_id': json['case_id'] == null ? undefined : json['case_id'],
        'user': UserFromJSON(json['user']),
        'read_at': json['read_at'] == null ? undefined : (new Date(json['read_at'])),
        'created_at': (new Date(json['created_at'])),
        'data': json['data'] == null ? undefined : json['data'],
    };
}

export function NotificationToJSON(json: any): Notification {
    return NotificationToJSONTyped(json, false);
}

export function NotificationToJSONTyped(value?: Notification | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'body': value['body'],
        'case_id': value['case_id'],
        'user': UserToJSON(value['user']),
        'read_at': value['read_at'] == null ? undefined : ((value['read_at']).toISOString().substring(0,10)),
        'created_at': ((value['created_at']).toISOString().substring(0,10)),
        'data': value['data'],
    };
}

